<template>
    <BorrarModalComponent
        :name="'borrar-' + ad_id"
        title="¿Seguro que quieres borrar este aviso?"
        confirmButton="¿BORRAR AVISO?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarAviso()"
    />
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['ad_id', 'evento_id'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.ad_id, borrado);
            },
            borrarAviso() {
                const params = {
                    filters : {},
                    ad_id: this.ad_id,
                    evento_id: this.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sales-ad.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
